// extracted by mini-css-extract-plugin
export default {"section":"KOK1aq","tile":"IqB0Ny","openIcon":"tFcggD","tileTitle":"IH0JvU","tileImage":"Mikybd","button":"noJfSF"};